import Parametres from '../types/api/Parametres';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Stack
} from '@mui/material';

interface ParametresFormProps {
    open: boolean,
    close: ()=>void,
    save: (parameters: Parametres)=>void,
    baseParametres: Parametres,
    updateParametres: (parameters: Parametres)=>void,
    confirmLabel: string
}

export function ParametresForm(ParametresFormProps: ParametresFormProps) {
    return (
        <Dialog 
            slotProps={{ paper: { elevation: 0, sx: { borderRadius: 2 } } }} 
            sx={{ p: { xs: 2, md: 3 } }} 
            open={ParametresFormProps.open} 
            maxWidth="sm" 
            fullWidth
        >
            <DialogTitle>Gestion des paramètres</DialogTitle>
            
            <DialogContent>
                <Stack spacing={3} sx={{ pt: 1 }}>
                    <TextField
                        label="Clé"
                        value={ParametresFormProps.baseParametres.key || ''}
                        onChange={(e) => ParametresFormProps.updateParametres({
                            ...ParametresFormProps.baseParametres,
                            key: e.target.value
                        })}
                        fullWidth
                        required
                    />

                    <TextField
                        label="Valeur"
                        value={ParametresFormProps.baseParametres.value || ''}
                        onChange={(e) => ParametresFormProps.updateParametres({
                            ...ParametresFormProps.baseParametres,
                            value: e.target.value
                        })}
                        fullWidth
                        required
                        multiline
                        minRows={3}
                    />
                </Stack>
            </DialogContent>
            
            <DialogActions>
                <Button onClick={ParametresFormProps.close} color="error">
                    Annuler
                </Button>
                <Button 
                    onClick={() => ParametresFormProps.save(ParametresFormProps.baseParametres)} 
                    variant="contained" 
                    color="primary"
                >
                    {ParametresFormProps.confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ParametresForm;